import "./tournament-sponsorship-tier-item.scss";
import { GSInfoGroup } from "golfstatus_react_components";

const TournamentSponsorshipTierItem = (props) => {
  const { name, sponsorCount, sponsorshipTierType } = props;
  const getSponsorCount = () => {
    if (sponsorCount < 1) {
      return "No Sponsors";
    } else {
      return `${sponsorCount} Sponsor${sponsorCount === 1 ? "" : "s"}`;
    }
  };

  const getName = () => {
    if (sponsorshipTierType === "default") {
      return `${name} (Default)`;
    } else {
      return name;
    }
  };

  let group = [
    {
      fit: "stretch",
      sections: [
        {
          type: "full-width",
          sectionItems: [
            { type: "primary full-wdith", value: `${getName()}` },
            { type: "secondary", value: `${getSponsorCount()}` },
          ],
        },
      ],
    },
  ];

  return (
    <div className={`sponsorship-tier-item ${sponsorshipTierType}`}>
      <GSInfoGroup dataGroups={group}></GSInfoGroup>
    </div>
  );
};

export default TournamentSponsorshipTierItem;
